import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TPageApi } from './types/pageApi.types'

export const pageApi = {
  getPage: (slug: string, { signal }: TSignalConfig) => fetcher.query<TPageApi>(`/page/${slug}`, { signal }),
}
